import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AppFeatureExtensions, JobFilterExtensions } from '@app/app-feature-extensions.config';
import { Job } from '@shared/models';

@Component({
  selector: 'mojo-job-card',
  templateUrl: './job-card.component.html',
  styleUrls: ['./job-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobCardComponent {
  @Input() job: Job;
  @Input() markedSearchPhrase: string;
  @Input() statusFilterType: JobFilterExtensions;

  externalSystemInformation = AppFeatureExtensions.EXTERNAL_SYSTEM_INFORMATION;
}
